/**
 * Jack.Hou
 * create views  mixins
 */
import {rsa} from "./rsa";
export default {
  /**
   * 判断返回结果
   */
  checkResponse(response) {
    if (response.code === '0000') {
      return true
    } else {
      return false
    }
  },
  /**
   * 是否空对象
   */
  isEmptyObj(obj) {
    if (obj === null || obj === undefined || obj === 'undefined') {
      return true
    } else {
      if (Object.keys(obj).length === 0) {
        return true
      }
      return false
    }
  },
  /**
   * 是否为空
   */
  isEmpty(val) {
    if (val === "" || val === 'undefined' || val === null || val === undefined) {
      return true
    } else {
      return false
    }
  },
  /**
   * 是否不为空
   */
  isNotEmpty(val) {
    return !this.isEmpty(val)
  },
  /**
   * cookes option
   */
  setCookie(name, value, days) {
    let d = new Date();
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
    window.document.cookie = name + '=' + value + ';path=/;expires=' + d.toGMTString();
  },
  getCookie(name) {
    let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
    let arr = document.cookie.match(reg);
    if (arr) {
      return unescape(arr[2]);
    } else {
      return null;
    }
  },
  delCookie(name) {
    let exp = new Date();
    exp.setTime(exp.getTime() - 1);
    let cval = this.getCookie(name);
    if (cval != null) {
      document.cookie = name + '=' + cval + ';path=/;expires=' + exp.toGMTString();
    }
  },
  /**
   * sessionStorage简单封装
   * @param {*} key
   * @param {*} objString
   */
  sessionSetItem(key, objString) {
    try {
      let stringObj = JSON.stringify(objString);
      if (window.sessionStorage) {
        window.sessionStorage.setItem(key, stringObj);
      } else {
        this.setCookie(key, JSON.stringify(stringObj));
      }
    } catch (e) {
      console.error(key, objString, e);
    }
  },
  /**
   * sessionStorage简单封装
   * @param {*} key
   * @param {*} objString
   */
  sessionGetItem(key) {
    if (!key) {
      console.error('window.sessionStorage get key is not');
      return null;
    }
    return JSON.parse(window.sessionStorage.getItem(key) || this.getCookie(key));
  },
  /**
   * sessionDelItem简单封装
   * @param {*} key
   * @param {*} objString
   */
  sessionDelItem(key) {
    if (!key) {
      console.error('window.sessionStorage del key is not');
      return;
    }
    window.sessionStorage.removeItem(key) || this.delCookie(key);
  },
  /**
   * 查询数据字典
   */
  queryPubParaDescList(selectDict) {
    let req = {
      whereDict: selectDict
    }
    return this.$store.dispatch("EASYPOST", {
      'urlKey': 'common/queryPubParaDescList',
      data: req
    })
  },
  queryPubTreeList(treeKey) {
    let req = {
      treeKey: treeKey
    }
    return this.$store.dispatch("EASYPOST", {
      'urlKey': 'common/queryPubTreeList',
      data: req
    })
  },


  /**
   * ren
   * create
   * 字典表增加key,value 
   */
  formatDictToArr(dic) {
    let data = [];
    let keyArr = [];
    for (let i in dic) {
      keyArr.push(i);
    }
    for (let j = 0; j < keyArr.length; j++) {
      let value = dic[keyArr[j]];
      let model = {};
      model.key = keyArr[j];
      model.value = value;
      data.push(model)
    }
    return data
  },
  /**
   * 获取当前时间
   * 格式YYYY-MM-DD
   */
  getNowFormatDate() {
    let date = new Date();
    let seperator1 = "-";
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let strDate = date.getDate();
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    let currentdate = year + seperator1 + month + seperator1 + strDate;
    // let currentdate = year + month + strDate;
    return currentdate;
  },
  /**
   * 时间去掉-
   * 格式YYYYMMDD
   */
  setDateFun(str) {
    let currentdate = str.replace(/-/g, '');
    return currentdate;
  },
  /**
   * 时间格式转为YYYY?MM?DD
   */
  unsetDateFun(val, str) {
    if (val) {
      let year = val.substr(0, 4);
      let month = val.substr(4, 2);
      let day = val.substr(6, 2);
      return year + str + month + str + day;
    } else {
      return val
    }
  },
  /**
    * 获取N个月前的时间
    * 
    */
  getBeforeMonth(str) {
    let date = new Date();
    let num = date.getMonth() - str;
    if (num < 0) {
      date.setFullYear(date.getFullYear() - 1)
      date.setMonth((12 + num))
    } else {
      date.setMonth(date.getMonth() - str)
    }
    let seperator1 = "-";
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let strDate = date.getDate();
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    // let currentdate = year + seperator1 + month + seperator1 + strDate;
    let currentdate = '';
    currentdate = year + '' + month + '' + strDate;
    return currentdate;
  },
  /**
   * 多长时间之前
   * @param time
   * @returns {*}
   */
  timeAgo(time) {
    const between = Date.now() / 1000 - Number(time);
    if (between < 3600) {
      return pluralize(~~(between / 60), ' minute');
    } else if (between < 86400) {
      return pluralize(~~(between / 3600), ' hour');
    } else {
      return pluralize(~~(between / 86400), ' day');
    }
  },

  // 格局化日期：date -> yyyy-MM-dd
  formatDate: function (date) {
    let myyear = date.getFullYear();
    let mymonth = date.getMonth() + 1;
    let myweekday = date.getDate();

    if (mymonth < 10) {
      mymonth = '0' + mymonth;
    }
    if (myweekday < 10) {
      myweekday = '0' + myweekday;
    }
    return (myyear + '-' + mymonth + '-' + myweekday);
  },
  // 获取下个月的时间
  getNextMonth(date) { // data =>  yyyy-MM-dd
    let arr = date.split('-');
    let year = arr[0]; //获取当前日期的年份
    let month = arr[1]; //获取当前日期的月份
    let day = arr[2]; //获取当前日期的日
    let days = new Date(year, month, 0);
    days = days.getDate(); //获取当前日期中的月的天数
    let year2 = year;
    let month2 = parseInt(month) + 1;
    if (month2 == 13) {
      year2 = parseInt(year2) + 1;
      month2 = 1;
    }
    let day2 = day;
    let days2 = new Date(year2, month2, 0);
    days2 = days2.getDate();
    if (day2 > days2) {
      day2 = days2;
    }
    if (month2 < 10) {
      month2 = '0' + month2;
    }

    let t2 = year2 + '-' + month2 + '-' + day2;
    return t2;
  },
  // 获得本周的开端日期
  getWeekStartDate: function () {
    let now = new Date(); // 当前日期
    let nowDayOfWeek = now.getDay(); // 今天本周的第几天
    let nowDay = now.getDate(); // 当前日
    let nowMonth = now.getMonth(); // 当前月
    let nowYear = now.getYear(); // 当前年
    nowYear += (nowYear < 2000) ? 1900 : 0;
    let weekStartDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek);
    return this.formatDate(weekStartDate);
  },
  // 获得本周的停止日期
  getWeekEndDate: function () {
    let now = new Date(); // 当前日期
    let nowDayOfWeek = now.getDay(); // 今天本周的第几天
    let nowDay = now.getDate(); // 当前日
    let nowMonth = now.getMonth(); // 当前月
    let nowYear = now.getYear(); // 当前年
    nowYear += (nowYear < 2000) ? 1900 : 0;
    let weekEndDate = new Date(nowYear, nowMonth, nowDay + (6 - nowDayOfWeek));
    return this.formatDate(weekEndDate);
  },

  //获得下周开始时间
  getNextWeekStartDate() {
    let now = new Date(); // 当前日期
    let nowDayOfWeek = now.getDay(); // 今天本周的第几天
    let nowDay = now.getDate(); // 当前日
    let nowMonth = now.getMonth(); // 当前月
    let nowYear = now.getYear(); // 当前年
    nowYear += (nowYear < 2000) ? 1900 : 0;
    let weekStartDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + 7);
    return this.formatDate(weekStartDate);
  },

  //获得下周结束时间
  getNextWeekEndDate() {
    let now = new Date(); // 当前日期
    let nowDayOfWeek = now.getDay(); // 今天本周的第几天
    let nowDay = now.getDate(); // 当前日
    let nowMonth = now.getMonth(); // 当前月
    let nowYear = now.getYear(); // 当前年
    nowYear += (nowYear < 2000) ? 1900 : 0;
    let weekEndDate = new Date(nowYear, nowMonth, nowDay + (6 - nowDayOfWeek) + 7);
    return this.formatDate(weekEndDate);
  },

  // 获得本月的开端日期
  getMonthStartDate: function () {
    let now = new Date(); // 当前日期
    let nowMonth = now.getMonth(); // 当前月
    let nowYear = now.getYear(); // 当前年
    nowYear += (nowYear < 2000) ? 1900 : 0;
    let monthStartDate = new Date(nowYear, nowMonth, 1);
    return this.formatDate(monthStartDate);
  },
  // 获得本月的停止日期
  getMonthEndDate: function () {
    let now = new Date(); // 当前日期
    let nowMonth = now.getMonth(); // 当前月
    let nowYear = now.getYear(); // 当前年
    nowYear += (nowYear < 2000) ? 1900 : 0;
    let monthEndDate = new Date(nowYear, nowMonth, this.getMonthDays(nowMonth));
    return this.formatDate(monthEndDate);
  },
  // 获得本季度的开端日期
  getQuarterStartDate: function () {
    let now = new Date(); // 当前日期
    let nowYear = now.getYear(); // 当前年
    nowYear += (nowYear < 2000) ? 1900 : 0;
    let quarterStartDate = new Date(nowYear, this.getQuarterStartMonth(), 1);
    return this.formatDate(quarterStartDate);
  },
  // 获得本季度的停止日期
  getQuarterEndDate: function () {
    let now = new Date(); // 当前日期
    let nowYear = now.getYear(); // 当前年
    nowYear += (nowYear < 2000) ? 1900 : 0;
    let quarterEndMonth = this.getQuarterStartMonth() + 2;
    let quarterStartDate = new Date(nowYear, quarterEndMonth, this.getMonthDays(quarterEndMonth));
    return this.formatDate(quarterStartDate);
  },
  //  获得本年的开始时间
  getQuarterYearStart: function () {
    let now = new Date(); // 当前日期
    let nowYear = now.getYear(); // 当前年
    nowYear += (nowYear < 2000) ? 1900 : 0;
    return nowYear + '-01-01';
  },
  //  获得本年的结束时间
  getQuarterYearEnd: function () {
    let now = new Date(); // 当前日期
    let nowYear = now.getYear(); // 当前年
    nowYear += (nowYear < 2000) ? 1900 : 0;
    return nowYear + '-12-31';
  },
  // 获得某月的天数
  getMonthDays: function (myMonth) {
    let now = new Date(); // 当前日期
    let nowYear = now.getYear(); // 当前年
    let monthStartDate = new Date(nowYear, myMonth, 1);
    let monthEndDate = new Date(nowYear, myMonth + 1, 1);
    let days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
    return days;
  },
  // 获得本季度的开端月份
  getQuarterStartMonth: function () {
    let now = new Date(); // 当前日期
    let nowMonth = now.getMonth(); // 当前月
    let nowYear = now.getYear(); // 当前年
    nowYear += (nowYear < 2000) ? 1900 : 0;
    let quarterStartMonth = 0;
    if (nowMonth < 3) {
      quarterStartMonth = 0;
    }
    if (2 < nowMonth && nowMonth < 6) {
      quarterStartMonth = 3;
    }
    if (5 < nowMonth && nowMonth < 9) {
      quarterStartMonth = 6;
    }
    if (nowMonth > 8) {
      quarterStartMonth = 9;
    }
    return quarterStartMonth;
  },
  //获得某季度的开始日期 和结束时间　　
  getSomeQuarterDate(paraYear, paraSeason) {
    let strDate = '',
      endDate = '';
    switch (paraSeason) {
      case '1':
        strDate = paraYear + "-01-01";
        endDate = paraYear + "-03-31";
        return [strDate, endDate];
      case '2':
        strDate = paraYear + "-04-01";
        endDate = paraYear + "-06-30";
        return [strDate, endDate];
      case '3':
        strDate = paraYear + "-07-01";
        endDate = paraYear + "-09-30";
        return [strDate, endDate];
      case '4':
        strDate = paraYear + "-10-01";
        endDate = paraYear + "-12-31";
        return [strDate, endDate];
    }
  },
  /**
   * 处理空字符串
   */
  handleEmpty(val) {
    if (this.isEmpty(val)) {
      return '--'
    } else {
      return val
    }
  },
  /**
   * 数字转金额
   */
  numberToChinese(money) {
    //汉字的数字  
    var cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖');
    //基本单位  
    var cnIntRadice = new Array('', '拾', '佰', '仟');
    //对应整数部分扩展单位  
    var cnIntUnits = new Array('', '万', '亿', '兆');
    //对应小数部分单位  
    var cnDecUnits = new Array('角', '分', '毫', '厘');
    //整数金额时后面跟的字符  
    var cnInteger = '整';
    //整型完以后的单位  
    var cnIntLast = '元';
    //最大处理的数字  
    var maxNum = 999999999999999.9999;
    //金额整数部分  
    var integerNum;
    //金额小数部分  
    var decimalNum;
    //输出的中文金额字符串  
    var chineseStr = '';
    //分离金额后用的数组，预定义  
    var parts;
    if (money == '') { return ''; }
    money = parseFloat(money);
    if (money >= maxNum) {
      //超出最大处理数字  
      return '';
    }
    if (money == 0) {
      chineseStr = cnNums[0] + cnIntLast + cnInteger;
      return chineseStr;
    }
    //转换为字符串  
    money = money.toString();
    if (money.indexOf('.') == -1) {
      integerNum = money;
      decimalNum = '';
    } else {
      parts = money.split('.');
      integerNum = parts[0];
      decimalNum = parts[1].substr(0, 4);
    }
    //获取整型部分转换  
    if (parseInt(integerNum, 10) > 0) {
      var zeroCount = 0;
      var IntLen = integerNum.length;
      for (var i = 0; i < IntLen; i++) {
        var n = integerNum.substr(i, 1);
        var p = IntLen - i - 1;
        var q = p / 4;
        var m = p % 4;
        if (n == '0') {
          zeroCount++;
        } else {
          if (zeroCount > 0) {
            chineseStr += cnNums[0];
          }
          //归零  
          zeroCount = 0;
          chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
        }
        if (m == 0 && zeroCount < 4) {
          chineseStr += cnIntUnits[q];
        }
      }
      chineseStr += cnIntLast;
    }
    //小数部分  
    if (decimalNum != '') {
      var decLen = decimalNum.length;
      for (var i = 0; i < decLen; i++) {
        var n = decimalNum.substr(i, 1);
        if (n != '0') {
          chineseStr += cnNums[Number(n)] + cnDecUnits[i];
        }
      }
    }
    if (chineseStr == '') {
      chineseStr += cnNums[0] + cnIntLast + cnInteger;
    } else if (decimalNum == '') {
      chineseStr += cnInteger;
    }
    return chineseStr;
  },
  /**
   * 数字转份额
   */
  assetToChinese(money) {
    //汉字的数字  
    var cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖');
    //基本单位  
    var cnIntRadice = new Array('', '拾', '佰', '仟');
    //对应整数部分扩展单位  
    var cnIntUnits = new Array('', '万', '亿', '兆');
    //对应小数部分单位  
    var cnDecUnits = new Array('角', '分', '毫', '厘');
    //整数金额时后面跟的字符  
    var cnInteger = '';
    //整型完以后的单位  
    var cnIntLast = '';
    //最大处理的数字  
    var maxNum = 999999999999999.9999;
    //金额整数部分  
    var integerNum;
    //金额小数部分  
    var decimalNum;
    //输出的中文金额字符串  
    var chineseStr = '';
    //分离金额后用的数组，预定义  
    var parts;
    if (money == '') { return ''; }
    money = parseFloat(money);
    if (money >= maxNum) {
      //超出最大处理数字  
      return '';
    }
    if (money == 0) {
      chineseStr = cnNums[0] + cnIntLast + cnInteger;
      return chineseStr;
    }
    //转换为字符串  
    money = money.toString();
    if (money.indexOf('.') == -1) {
      integerNum = money;
      decimalNum = '';
    } else {
      parts = money.split('.');
      integerNum = parts[0];
      decimalNum = parts[1].substr(0, 4);
    }
    //获取整型部分转换  
    if (parseInt(integerNum, 10) > 0) {
      var zeroCount = 0;
      var IntLen = integerNum.length;
      for (var i = 0; i < IntLen; i++) {
        var n = integerNum.substr(i, 1);
        var p = IntLen - i - 1;
        var q = p / 4;
        var m = p % 4;
        if (n == '0') {
          zeroCount++;
        } else {
          if (zeroCount > 0) {
            chineseStr += cnNums[0];
          }
          //归零  
          zeroCount = 0;
          chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
        }
        if (m == 0 && zeroCount < 4) {
          chineseStr += cnIntUnits[q];
        }
      }
      chineseStr += cnIntLast;
    }
    //小数部分  
    console.log(chineseStr)
    if (decimalNum != '') {
      var decLen = decimalNum.length;
      for (var i = 0; i < decLen; i++) {
        var n = decimalNum.substr(i, 1);
        if (n != '0') {
          if (i == 0) chineseStr += '点'
          chineseStr += cnNums[Number(n)];
        }
      }
    }
    if (chineseStr == '') {
      chineseStr += cnNums[0] + cnIntLast + cnInteger;
    } else if (decimalNum == '') {
      chineseStr += cnInteger;
    }
    return chineseStr;
  },
  /**
  * 三位一瞥
  * @param {*} string
  * @param {*} string
  */
  numberFormat(value) {
    if (!value) return '0.00';
    var intPart = Number(value).toFixed(0); //获取整数部分
    var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断
    var floatPart = ".00"; //预定义小数部分
    var value2Array = value.split(".");
    //=2表示数据有小数位
    if (value2Array.length == 2) {
      floatPart = value2Array[1].toString(); //拿到小数部分
      if (floatPart.length == 1) { //补0,实际上用不着
        return intPartFormat + "." + floatPart + '0';
      } else {
        return intPartFormat + "." + floatPart;
      }
    } else {
      return intPartFormat + floatPart;
    }
  },
  /**
  * 保留两位小数
  * @param {*} string
  * @param {*} Number
  */
  keepTwoNum(val){
    if(this.isNotEmpty(val)){
      val = Number(val)
      return val.toFixed(2)
    }else{
      return val
    }
  },
  /**
    * 金额转换 格式化成正整数或者保留两位小数的数字
    * @param {*} string
    * @param {*} amount
    */
   changeAmount(value){
    var price = '' + value;
    price = price
        .replace(/[^\d.]/g, '') // 清除“数字”和“.”以外的字符
        .replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
        .replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); // 只能输入两个小数
    if (price.indexOf('.') < 0 && price != '') {
        // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        price = parseFloat(price);
    }
    return price;
  },
  /**
    * 金额校验 校验正整数或者保留两位小数的数字
    * @param {*} string
    * @param {*} amount
    */
  isMoney(value) {
        //金额 只允许正数
        var exp = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/; 
        //金额 允许正（+）负数
        //var exp = /(^([+-]?)[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^([+-]?)(0){1}$)|(^([+-]?)[0-9]\.[0-9]([0-9])?$)/; 
        //金额 允许正负数
        //var exp = /(^([-]?)[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^([-]?)(0){1}$)|(^([-]?)[0-9]\.[0-9]([0-9])?$)/; 
        if(exp.test(value)) {
            return true;
        } else {
            return false;
        }
   },
  /**
    * RSA加密
    * @param {*} string
    * @param {*} number
    */
   rsaEncrypt(value){
      if (window.config.RSA === 'true' || window.config.RSA === true) {
        return rsa(value)
      }else{
        return value
      }
   } 
}
